import { FF1 } from "@noble/ciphers/ff1";
import type { FPEEncryptionOptions } from "../../types";

export interface FPEEncryptParameters {
	data: number[];
	key: CryptoKey;
}

export interface FPEDecryptParameters {
	data: number[];
	key: CryptoKey;
}

export class FPE {
	constructor(
		private readonly options: FPEEncryptionOptions = {
			radix: 10,
		},
	) {}

	private async getFf1(key: CryptoKey): Promise<ReturnType<typeof FF1>> {
		const encryptionKey = await this.exportSymmetricEncryptionKey(key);
		return FF1(this.options.radix, encryptionKey, this.options.tweak);
	}

	async encrypt(options: FPEEncryptParameters): Promise<number[]> {
		const { data, key } = options;
		const ff1 = await this.getFf1(key);
		if (data.some((d) => d >= this.options.radix)) {
			throw new Error("Data contains values greater than the radix");
		}
		return ff1.encrypt(data);
	}

	async decrypt(options: FPEDecryptParameters): Promise<number[]> {
		const { data, key } = options;
		const ff1 = await this.getFf1(key);
		if (data.some((d) => d >= this.options.radix)) {
			throw new Error("Data contains values greater than the radix");
		}
		return ff1.decrypt(data);
	}

	private async exportSymmetricEncryptionKey(
		key: CryptoKey,
	): Promise<Uint8Array> {
		return new Uint8Array(await crypto.subtle.exportKey("raw", key));
	}
}
